export default __webpack_public_path__ + "static/media/email.e74104f4.svg";